import { render, staticRenderFns } from "./editHideGlobalComponents.vue?vue&type=template&id=79c89e25&"
import script from "./editHideGlobalComponents.vue?vue&type=script&lang=js&"
export * from "./editHideGlobalComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports